import { render, staticRenderFns } from "./WaiverAdminList.vue?vue&type=template&id=13850ed5&"
import script from "./WaiverAdminList.vue?vue&type=script&lang=js&"
export * from "./WaiverAdminList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports